import O1HD from "../../engines/gameEngine";

const {ccclass, property} = cc._decorator;
/**
 * 闲置通知
 */
@ccclass
export default class IdleNoticePrefab extends cc.Component {

    onLoad () {}

    start () {

    }

    onBtnMakeSure(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

    // update (dt) {}
}
